module.exports = __webpack_public_path__ + "img/indipendentday-logo.dca6e8ed.png";